import { Link } from "react-router-dom";

/**
 * 404 page shown for any route that doesn't match a defined path.
 *
 * Deliberately library-agnostic (plain Tailwind + react-router `Link`): it
 * renders inside both the Antd analytics shell (GeneralLayout) and the
 * shadcn-scoped `/ai` area, so it must not pull either UI library into the
 * other's scope. The `Link` to "/" gives the user a way out instead of a
 * dead-end blank page (the prior behavior — no catch-all route existed).
 */
const NotFound = () => {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center px-6 text-center">
      <p className="text-7xl font-bold leading-none text-gray-300">404</p>
      <h1 className="mt-4 text-xl font-semibold text-gray-800">
        Page not found
      </h1>
      <p className="mt-2 max-w-md text-sm text-gray-500">
        The page you&rsquo;re looking for doesn&rsquo;t exist or may have been
        moved.
      </p>
      <Link
        to="/"
        className="mt-6 inline-flex items-center rounded-md bg-[#0E49B5] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[#0c3d99]"
      >
        Back to home
      </Link>
    </div>
  );
};

export default NotFound;
